import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * @typedef {Object} InventoryEntry
 * @property {string} html
 * @property {boolean} visible
 */

/** @typedef {Record<string, InventoryEntry>} InventoryMap */

class ProductInventory extends Component {
  /** @type {InventoryMap | null} */
  #inventoryMap = null;

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /** @returns {InventoryMap} */
  get inventoryMap() {
    if (this.#inventoryMap) return this.#inventoryMap;
    const json = this.querySelector('script[type="application/json"]')?.textContent;
    if (!json) return {};
    try {
      this.#inventoryMap = /** @type {InventoryMap} */ (JSON.parse(json));
      return this.#inventoryMap;
    } catch {
      return {};
    }
  }

  /** @param {Event} event */
  updateInventory = (event) => {
    if (!(event instanceof VariantUpdateEvent)) return;

    const variant = /** @type {{id?: string | number} | null} */ (event.detail?.resource);
    if (!variant?.id) return;

    const entry = this.inventoryMap[String(variant.id)];
    if (!entry) {
      this.hidden = true;
      return;
    }

    const status = this.querySelector('[ref="status"]');
    if (status) {
      status.innerHTML = entry.html;
    }
    this.hidden = !entry.visible;
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
